import { createContext } from 'react';

import type {
  FeatureInstances,
  PlayerEvents,
  PlayerStore,
} from '@iconik-io/unified-player-core';

export type PlayerContextValue<PlaylistItemMeta> = {
  store: PlayerStore<PlaylistItemMeta>;
  features: FeatureInstances<PlaylistItemMeta>;
  playerEvents: PlayerEvents;
};

export const PlayerContext = createContext<PlayerContextValue<unknown> | null>(
  null,
);
